<mat-toolbar class="header-toolbar">
  <!-- Logo Section -->
  <div class="header-logo-section" (click)="onLogoClick()" role="button" tabindex="0">
    <img src="/assets/images/PSLLogoWhite.png" alt="PSL Logo" class="logo-image">
  </div>

  <!-- Right Section -->
  <div class="header-right-section">
    <!-- Search Bar (Expandable) -->
    <!-- <div class="search-container" [class.expanded]="searchExpanded">
      <input 
        type="text" 
        class="search-input"
        placeholder="Search..."
        [(ngModel)]="searchQuery"
        (keyup.enter)="onSearchSubmit()"
        #searchInput>
    </div> -->
    
    <!-- Search Button -->
    <!-- <button mat-icon-button class="header-icon-btn" (click)="toggleSearch()">
      <mat-icon svgIcon="search-white"></mat-icon>
    </button> -->

    <!-- Cleaning Status Indicator -->
    <div class="cleaning-indicator" *ngIf="shouldShowCleaningStatus">
      <!-- Single Clean Display -->
      <ng-container *ngIf="!shouldShowMultiCleanSummary && singleCleaningStatus">
        <mat-spinner *ngIf="singleCleaningStatus.state === 'in-progress'" diameter="20" class="cleaning-spinner"></mat-spinner>
        <mat-icon *ngIf="singleCleaningStatus.state === 'success'" svgIcon="check_circle_green" class="cleaning-status-icon"></mat-icon>
        <mat-icon *ngIf="singleCleaningStatus.state === 'error'" svgIcon="warning" class="cleaning-status-icon cleaning-status-icon--error"></mat-icon>
        <div class="cleaning-indicator-content">
          <span class="cleaning-label">
            <strong>{{ singleCleaningStatus.projectName }}</strong>
          </span>
          <ng-container *ngIf="singleCleaningStatus.state === 'in-progress'">
            <mat-progress-bar *ngIf="singleCleaningStatus.totalSteps && (singleCleaningStatus.currentStep ?? 0) > 0" mode="determinate" [value]="((singleCleaningStatus.currentStep ?? 0) / singleCleaningStatus.totalSteps) * 100" class="cleaning-progress-bar"></mat-progress-bar>
            <mat-progress-bar *ngIf="!singleCleaningStatus.totalSteps || (singleCleaningStatus.currentStep ?? 0) === 0" mode="indeterminate" class="cleaning-progress-bar"></mat-progress-bar>
            <span class="cleaning-step-label">
              {{ ((singleCleaningStatus.currentStep ?? 0) > 0 && singleCleaningStatus.totalSteps) ? ('Step ' + singleCleaningStatus.currentStep + ' of ' + singleCleaningStatus.totalSteps + (singleCleaningStatus.goalName ? ' - ' + singleCleaningStatus.goalName : '') + (singleCleaningStatus.columnName ? ' (' + singleCleaningStatus.columnName + ')' : '')) : singleCleaningStatus.message }}
            </span>
          </ng-container>
        </div>
      </ng-container>

      <!-- Multi-Clean Summary -->
      <ng-container *ngIf="shouldShowMultiCleanSummary">
        <div class="multi-clean-summary" (click)="toggleCleaningDropdown()">
          <mat-spinner diameter="20" class="cleaning-spinner"></mat-spinner>
          <div class="cleaning-indicator-content">
            <span class="cleaning-label">
              <strong>{{ inProgressCount }} Workflows in Progress</strong>
            </span>
            <span class="cleaning-step-label">Click to see more</span>
          </div>
        </div>

        <!-- Dropdown Overlay -->
        <div class="cleaning-dropdown-overlay" *ngIf="cleaningDropdownOpen" (click)="closeCleaningDropdown()"></div>
        
        <!-- Dropdown Menu -->
        <div class="cleaning-dropdown" *ngIf="cleaningDropdownOpen" (click)="$event.stopPropagation()">
          <div class="cleaning-dropdown-header">
            <span>Active Workflows</span>
            <button mat-icon-button (click)="closeCleaningDropdown()" class="close-btn">
              <mat-icon>close</mat-icon>
            </button>
          </div>
          <div class="cleaning-dropdown-content">
            <div class="cleaning-card" *ngFor="let status of visibleCleaningStatuses">
              <div class="cleaning-card-header">
                <mat-icon *ngIf="status.state === 'success'" svgIcon="check_circle_green" class="cleaning-card-icon"></mat-icon>
                <mat-icon *ngIf="status.state === 'error'" svgIcon="warning" class="cleaning-card-icon cleaning-card-icon--error"></mat-icon>
                <span class="cleaning-card-title">{{ status.projectName }}</span>
              </div>
              <div class="cleaning-card-body" *ngIf="status.state === 'in-progress'">
                <mat-progress-bar *ngIf="status.totalSteps && (status.currentStep ?? 0) > 0" mode="determinate" [value]="((status.currentStep ?? 0) / status.totalSteps) * 100" class="cleaning-card-progress"></mat-progress-bar>
                <mat-progress-bar *ngIf="!status.totalSteps || (status.currentStep ?? 0) === 0" mode="indeterminate" class="cleaning-card-progress"></mat-progress-bar>
                <span class="cleaning-card-details">
                  {{ ((status.currentStep ?? 0) > 0 && status.totalSteps) ? ('Step ' + status.currentStep + ' of ' + status.totalSteps + (status.goalName ? ' - ' + status.goalName : '') + (status.columnName ? ' (' + status.columnName + ')' : '')) : status.message }}
                </span>
              </div>
              <div class="cleaning-card-body" *ngIf="status.state === 'success'">
                <span class="cleaning-card-details cleaning-card-details--success">Clean completed successfully</span>
              </div>
              <div class="cleaning-card-body" *ngIf="status.state === 'error'">
                <span class="cleaning-card-details cleaning-card-details--error">Clean failed</span>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <!-- View Mode Toggle -->
    <!-- View Mode Toggle -->
    <!-- <div class="mode-toggle-container">
      <button 
        class="mode-toggle-btn" 
        [class.active]="viewMode === 'simple'"
        (click)="setViewMode('simple')">
        Simple
      </button>
      <button 
        class="mode-toggle-btn" 
        [class.active]="viewMode === 'advanced'"
        (click)="setViewMode('advanced')">
        Advanced
      </button>
    </div> -->

    <!-- Environment Badge -->
    <div 
      class="environment-badge" 
      *ngIf="environmentName" 
      [class.env-dev]="environmentName === 'DEV'" 
      [class.env-uat]="environmentName === 'UAT'"
      [matTooltip]="environmentTooltip"
      matTooltipClass="environment-tooltip"
      matTooltipPosition="below">
      {{ environmentName }}
    </div>

    <!-- Help Button (now opens help dropdown) -->
    <button mat-icon-button class="header-icon-btn help-icon-btn" *ngIf="currentUser" (click)="toggleHelpMenu($event)">
      <mat-icon svgIcon="question-mark-white"></mat-icon>
    </button>

    <div class="user-menu-dropdown help-menu-dropdown new-menu-dropdown user-menu" *ngIf="showHelpMenu" (click)="$event.stopPropagation()">
      <button class="new-menu-item" (click)="onHelp()">
        <span>Help & Support</span>
      </button>
      <div class="new-menu-separator"></div>
      <a class="new-menu-item" href="https://dqp.powerserve.global/privacy-policy" target="_blank" rel="noopener">
        <span>Privacy Policy</span>
      </a>
      <a class="new-menu-item" href="https://dqp.powerserve.global/cookie-policy" target="_blank" rel="noopener">
        <span>Cookie Policy</span>
      </a>
      <a class="new-menu-item" href="https://dqp.powerserve.global/data-processing-agreement" target="_blank" rel="noopener">
        <span>Data Processing Agreement</span>
      </a>
      <div class="new-menu-separator"></div>
      <a class="new-menu-item" href="https://dqp.powerserve.global/support" target="_blank" rel="noopener">
        <span>Contact Support</span>
      </a>
    </div>

    <!-- Settings Button -->
    <!-- <button mat-icon-button class="header-icon-btn">
      <mat-icon svgIcon="setting-white"></mat-icon>
    </button> -->

    <!-- User Profile Menu (custom dropdown to match new-menu-dropdown) -->
    <button mat-icon-button class="header-icon-btn user-icon-btn" *ngIf="currentUser" (click)="toggleUserMenu($event)">
      <mat-icon svgIcon="user-white"></mat-icon>
    </button>

    <div class="user-menu-dropdown new-menu-dropdown user-menu" *ngIf="showUserMenu" (click)="$event.stopPropagation()">
      <div class="user-menu-header">
        <mat-icon svgIcon="user" class="user-section-icon"></mat-icon>
        <div class="user-menu-info">
          <span class="name">{{ getUserFullName() }}</span>
          <span class="username">{{ currentUser?.username || 'Guest' }}</span>
          <span class="organization">{{ currentUser?.companyName || 'No Organization' }}</span>
        </div>
      </div>
      <div class="nav-separator"></div>

      <div class="user-menu-header">
        <div class="user-menu-info">
          <div class="user-menu-item" *ngIf="currentUser?.plan?.displayName || currentUser?.trialExpiresAt">
            <mat-icon svgIcon="gem"></mat-icon>
            <div class="user-plan">
              <span class="plan-name">{{ currentUser?.plan?.displayName }}</span>
              <div *ngIf="currentUser?.trialExpiresAt" class="trial-expires">Expires: {{ currentUser?.trialExpiresAt | date:'mediumDate' }}</div>
              <div class="plan-actions">
                <a href="#" class="plan-details-link" (click)="openUsageSummary($event)" role="button" tabindex="0">Plan details</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="nav-separator"></div>
      <button class="new-menu-item" (click)="onUserManagement()">
        <mat-icon svgIcon="user" class="menu-item-icon"></mat-icon>
        <span>User Management</span>
      </button>
      <button class="new-menu-item" (click)="onChangePassword()">
        <mat-icon svgIcon="lock" class="menu-item-icon"></mat-icon>
        <span>Change Password</span>
      </button>
      <div class="new-menu-separator"></div>
      <button class="new-menu-item logout-item" (click)="onLogout()">
        <mat-icon svgIcon="logout" class="menu-item-icon"></mat-icon>
        <span>Logout</span>
      </button>
    </div>
  </div>
</mat-toolbar>
